import { takeEvery, put, call, SagaReturnType } from 'redux-saga/effects';
import { PatientPayersActions } from 'src/redux/actions/constant';
import patientService from 'src/services/apiServices/patientService';

const {
  GET_PAYER_OPTIONS_REQUEST,
  GET_PAYER_OPTIONS_SUCCESS,
  GET_PAYER_OPTIONS_FAILURE,
  GET_PAYER_OPTIONS_LOADING,
} = PatientPayersActions;

function* getPayerOptions(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_PAYER_OPTIONS_LOADING });
    const response = yield call(patientService.getPayerOptions, action.payload);
    if (response?.status === 200) {
      yield put({ type: GET_PAYER_OPTIONS_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_PAYER_OPTIONS_FAILURE, payload: error });
  }
}

function* getPayerOptionsSaga() {
  yield takeEvery(GET_PAYER_OPTIONS_REQUEST, getPayerOptions);
}

export default getPayerOptionsSaga;
